<img src="{{flagFilePath}}" class="lang {{currentLangClass}}" (click)="onClick()">
